import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_find_serialnumbersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number }): 
  Promise<{ result: { Id?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number    }) {
      return false;
    }
}
